import { fileUrl } from "@/lib/images";
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Camera, X } from "lucide-react";

const PALETTE = ["#0B6B4F", "#EA580C", "#2563EB", "#7C3AED", "#DB2777", "#0891B2", "#CA8A04", "#DC2626", "#059669", "#4F46E5"];
const hashStr = (s) => { let h = 0; for (let i = 0; i < (s || "").length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0; return h; };

// Auth'lu dosya URL'i (serve_file ?auth= bekler)
export { fileUrl };

const initials = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toLocaleUpperCase("tr");
};

export function EntityAvatar({ src, name, size = 40, className = "" }) {
  const color = PALETTE[hashStr(name || "") % PALETTE.length];
  return (
    <Avatar style={{ height: size, width: size }} className={className} data-testid="entity-avatar">
      {src ? <AvatarImage src={fileUrl(src)} alt={name || ""} className="object-cover" /> : null}
      <AvatarFallback style={{ backgroundColor: color }} className="font-heading font-semibold text-white">
        <span style={{ fontSize: Math.max(10, Math.round(size * 0.4)) }}>{initials(name)}</span>
      </AvatarFallback>
    </Avatar>
  );
}

export function AvatarUpload({ value, name, onChange, size = 64, label = "Görsel / Avatar" }) {
  const [busy, setBusy] = useState(false);
  const up = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    if (f.size > 6 * 1024 * 1024) { toast.error("Görsel 6MB'den küçük olmalı"); e.target.value = ""; return; }
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const { data } = await api.post("/uploads/document", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url); toast.success("Görsel yüklendi");
    } catch (er) { toast.error("Görsel yüklenemedi"); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="flex items-center gap-3">
      <EntityAvatar src={value} name={name} size={size} className="ring-2 ring-slate-100" />
      <div className="flex flex-col items-start gap-1">
        <label className="inline-flex cursor-pointer items-center gap-1.5 rounded-md border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-50">
          <Camera className="h-3.5 w-3.5" /> {busy ? "Yükleniyor..." : label}
          <input data-testid="avatar-upload-input" type="file" accept=".png,.jpg,.jpeg,.webp" className="hidden" onChange={up} />
        </label>
        {value ? (
          <button type="button" data-testid="avatar-remove-btn" onClick={() => onChange("")}
            className="inline-flex items-center gap-1 text-[11px] font-medium text-red-500 hover:underline">
            <X className="h-3 w-3" /> Kaldır
          </button>
        ) : null}
      </div>
    </div>
  );
}
